import React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const DeletedStreamsWarning = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning", title: t("deleted_streams_warning.title") }, t("deleted_streams_warning.text", { deletedStream: t("labels.deleted_stream") }));
};
export default DeletedStreamsWarning;
